define('shoptheme/components/layout/navigation',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire",
	"jquery-menu-aim",
	"modernizr",
	"bootstrap-collapse",
	"jquery-dlmenu"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints,
	enquire,
	menuAim
) {
	return Component.create({
		blocks:					null,
		path:					null,
		area:					null,
		additionalCategories:	null,
		topmenu:				null,
		desktopAimInitialized:	false,

		$init: function() {
			var menuItemClass = "." + BEM.buildElementClassname("nav", "menu-item", "level0");

			this.blocks = BEM.block("nav");

			this.path = _.get(window, "gigaset.category.current");
			this.area = _.get(window, "gigaset.area");
			this.additionalCategories = _.get(window, "gigaset.category.additional");
			this.topmenu = $("#topmenu");

			_.forEach(_.union(this.path, [this.area], this.additionalCategories), function(categoryId) {
				var nodeId = ((categoryId|0) == categoryId)
					? "category-node-" + categoryId
					: categoryId;

				this.blocks.find('[data-category-id="' + nodeId + '"]').bemAddModifier("active");
			}, this);

			$(document).on("mouseenter", menuItemClass, function(e) {
				$(e.currentTarget).addClass("hover");
			}).on("mouseleave", menuItemClass, function(e) {
				$(e.currentTarget).removeClass("hover");
			});

			this.topmenu.dlmenu({
				useActiveItemAsLink: true
			});

			this.initResponsive();

			this.prepareCustomerAccountNavigation();

			this.desktopMenuAim();

		},

		initResponsive: function() {
			enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
				match: _.bind(this.layoutDesktop, this),
				unmatch: _.bind(this.layoutMobile, this)
			}, true);
		},

		layoutMobile: function() {

			var menus = this.blocks.getElements("menu");

			menus.addClass("dl-submenu");

			menus.filter(":modifier(level0)").each(function() {
				var menu = $(this);
				menu.bemParents("menu-item").bemGetElements("submenu-slot-mobile").before(menu);
			});

			this.topmenu.addClass("dl-menuwrapper");
		},

		layoutDesktop: function() {

			var menus = this.blocks.getElements("menu");

			menus.removeClass("dl-submenu");

			menus.filter(":modifier(level0)").each(function(i) {
				var menu = $(this);
				menu.bemParents("menu-item").bemGetElements("submenu-slot-desktop").append(menu);
			});

			this.topmenu.removeClass("dl-menuwrapper");
		},

		prepareCustomerAccountNavigation: function() {
			if ($('html').hasClass('ie8')) return;
			var customerAccountMobileNav = $('.b_account-mobile-nav');
			if (customerAccountMobileNav.length > 0) {
				customerAccountMobileNav.prependTo($('.b_main-container__col2-left-col-main'));
				$('select', customerAccountMobileNav).on('change', function() {
					window.location = $(this).val();
				})
			}
		},

		desktopMenuAim: function() {
			$(document.body).one("mouseenter", "." + BEM.buildElementClassname("nav", "menu-item"), _.bind(function() {

				var menus = this.blocks.getElements("menu");
				var link = BEM.buildElementClassname("nav", "menu-item-link", "level1")

				menus.menuAim({
					activate: activateSubmenu,
					deactivate: deactiveSubmenu,
					rowSelector: "> li." + BEM.buildElementClassname("nav", "menu-item", "level1"),
					exitMenu: deactiveSubmenu
				});

				function activateSubmenu(row) {
					var $row = $(row);

					if($row.hasClass('b_nav__menu-item--parent')) {
						$row.parent('ul').addClass('removeHover');
					}

					$submenu = $row.find('ul');
					$submenu.addClass('open');

					$menulink = $row.find('.' + link);
					$menulink.addClass('maintainHover');
				}

				function deactiveSubmenu(row) {
					var $row = $(row);

					$row.parent('ul').removeClass('removeHover');

					$submenu = $row.find('ul');
					$submenu.removeClass('open');

					$menulink = $row.find('.' + link);
					$menulink.removeClass('maintainHover');

					return true;
				}
			}, this));
		}
	});
});
